import { createEffect, createSignal, onCleanup } from "solid-js";

export const useElementHeight = (elAccessor: () => HTMLElement | undefined) => {
  const [height, setHeight] = createSignal(0);

  createEffect(() => {
    const el = elAccessor();
    if (!el) {
      setHeight(0);
      return;
    }

    const handleResize = () => {
      setHeight(el.getBoundingClientRect().height);
    };

    const ro = new ResizeObserver(handleResize);
    ro.observe(el);
    handleResize();

    onCleanup(() => {
      ro.disconnect();
    });
  });

  return height;
};
